/* eslint-disable max-len */

import React, { DetailedHTMLProps, HTMLAttributes } from 'react'

interface Props extends DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  svgStyles?: string
}

const CloseXSvg = (props: Props): JSX.Element => {
  const { svgStyles, ...rest } = props

  const img = `
<svg class="${
    props.svgStyles ?? ''
  }" xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 19.861 19.86" preserveAspectRatio="xMidYMid meet">
  <g id="Group_2784" data-name="Group 2784" transform="translate(-43.571 -16.216) rotate(-135)">
    <g id="Group_2660" data-name="Group 2660" transform="translate(-67.672 7.3)">
      <line id="Line_217" data-name="Line 217" y2="24.086" transform="translate(11.353)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-width="2"/>
      <line id="Line_232" data-name="Line 232" y2="24.086" transform="translate(23.396 12.043) rotate(90)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-width="2"/>
    </g>
  </g>
</svg>
  `
  return <div {...rest} dangerouslySetInnerHTML={{ __html: img }} />
}

export default CloseXSvg
